import { render, staticRenderFns } from "./RemNewMessage.vue?vue&type=template&id=78ed5260&scoped=true&"
import script from "./RemNewMessage.vue?vue&type=script&lang=js&"
export * from "./RemNewMessage.vue?vue&type=script&lang=js&"
import style0 from "./RemNewMessage.vue?vue&type=style&index=0&id=78ed5260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ed5260",
  null
  
)

export default component.exports